import React from 'react';
import PropTypes from 'prop-types';

const JourneyValue = ({
  title, value, formatFunction, units,
}) => (!value ? false :
<div className="md-text-right journeyValue">
  <div className="md-font-semibold">{title}</div>
  <div>{formatFunction ? formatFunction(value) : value}{units}</div>
</div>);

JourneyValue.propTypes = {
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  formatFunction: PropTypes.func,
  units: PropTypes.string,
};

export default JourneyValue;



// WEBPACK FOOTER //
// ./src/components/Journey/JourneyValue.js